<template>
    <b-modal id="createModal" ref="modal" title="Register a Grower" v-model="show" @ok="handleSubmit" @hide="close" @shown="focusNameInput">

        <div class="form-group">
            <label>Grower Name</label>
            <div class="position-relative">
                <input type="text" ref="nameInput" name="name" v-validate="{required: true}" class="form-control" v-model="name">
                <div class="invalid-feedback" v-if="errors.has('name')">{{ errors.first('name') }}</div>
                <i class="form-group__bar"></i>
            </div>
        </div>

        <div class="form-group">
            <label>Business Name</label>
            <div class="position-relative">
                <input type="text" name="business_name" v-validate="{required: true}" class="form-control" v-model="business_name">
                <div class="invalid-feedback" v-if="errors.has('business_name')">{{ errors.first('business_name') }}</div>
                <i class="form-group__bar"></i>
            </div>
        </div>

        <div class="form-group">
            <label>Grower Password</label>
            <div class="position-relative">
                <input type="text" name="password" v-validate="{required: true}" class="form-control" v-model="password">
                <div class="invalid-feedback" v-if="errors.has('password')">{{ errors.first('password') }}</div>
                <i class="form-group__bar"></i>
            </div>
        </div>

        <div class="form-group">
            <label>Grower Email</label>
            <div class="position-relative">
                <input type="text" name="email" v-validate="{required: true, email: true}" class="form-control" v-model="email">
                <div class="invalid-feedback" v-if="errors.has('email')">{{ errors.first('email') }}</div>
                <i class="form-group__bar"></i>
            </div>
        </div>

        <div class="form-group">
            <label>Region</label>
            <div class="position-relative">
                <VueSelect
                        v-validate="{required: true}"
                        data-vv-name="region"
                        v-model="region"
                        :options="linkedCountries"
                        :allow-empty="false"
                        deselect-label=""
                        placeholder="Region"
                        group-values="regions"
                        group-label="name"
                        label="name"
                        track-by="id"
                >
                </VueSelect>
                <div class="invalid-feedback" v-if="errors.has('region')">{{ errors.first('region') }}</div>
                <i class="form-group__bar"></i>
            </div>
        </div>


        <template slot="modal-footer">
            <button class="btn btn-secondary" @click="close">
                Cancel
            </button>
            <button class="btn btn-primary" :disabled="okDisabled" @click="handleSubmit">
                Save
            </button>
        </template>
    </b-modal>
</template>


<script>
import listUsersQuery from '@views/Growers/ProcessorBrowse/queryListGrowers.graphql';
import createGrowerMutation from './CreateModal/mutationCreateGrower.graphql';
import listLinkedRegionsQuery from './CreateModal/queryListProcessorLinkedRegions.graphql';

export default {
  name: 'create-modal',
  apollo: {
    linkedRegions: {
      query: listLinkedRegionsQuery,
      update: data => data.filterProcessorRegionLinks,
    },
  },
  props: {
    close: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      name: '',
      business_name: '',
      email: '',
      password: '',
      region: null,
      linkedRegions: [],
      show: true,
      loading: 0,
    };
  },
  computed: {
    linkedCountries() {
      const groups = [];
      this.linkedRegions.forEach(region => {
        const countryIndex = groups.findIndex(country => region.country.id === country.id);
        if (countryIndex === -1) {
          groups.push({ ...region.country, regions: [region] });
        } else {
          groups[countryIndex].regions.push(region);
        }
      });

      return groups;
    },
    okDisabled() {
      return this.name.length === 0 || this.password.length === 0 || this.email.length === 0 || !this.region;
    },
  },
  methods: {
    handleSubmit() {
      if (this.okDisabled) {
        return false;
      }
      this.errors.remove('global');
      this.$validator.validateAll().then(validationWasSuccessful => {
        if (!validationWasSuccessful) {
          return;
        }

        this.$apollo
          .mutate({
            mutation: createGrowerMutation,
            refetchQueries: [
              { query: listUsersQuery },
            ],
            variables: {
              input: {
                'name': this.name,
                'business_name': this.business_name,
                'email': this.email,
                'password': this.password,
                'region_id': this.region.id,
              },
            },
          })
          .then(() => {
            this.$notifySuccess('Grower created!');
            this.$emit('refresh');
            this.close();
          })
          .catch(err => this.$mapGraphQLError(err))
          .catch(err => {
            console.error(err);
            this.$notifyFailure('Unfortunately, we were unable to do that!');
          });
      });
    },
    focusNameInput() {
      this.$refs.nameInput.focus();
    },
  },
};
</script>
